import { render, staticRenderFns } from "./Project18.vue?vue&type=template&id=aa7fe7a8&scoped=true&"
import script from "./Project18.vue?vue&type=script&lang=js&"
export * from "./Project18.vue?vue&type=script&lang=js&"
import style0 from "./Project18.vue?vue&type=style&index=0&id=aa7fe7a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7fe7a8",
  null
  
)

export default component.exports